import React from "react";

type ScopeAttributes = Readonly<Record<`data-${string}`, string>>;

const PortalScopeContext = React.createContext<ScopeAttributes>({});

/**
 * Data attributes a part of the page puts on every pop-up it opens, nested ones included: a pop-up's DOM leaves the page
 * for `body`, but its React context does not, so styles scoped to the page reach it there. With no scope it adds nothing.
 */
interface PortalScopeProps {
  attributes: ScopeAttributes;
  children: React.ReactNode;
}
export const PortalScope = ({ attributes, children }: PortalScopeProps) => (
  <PortalScopeContext.Provider value={attributes}>{children}</PortalScopeContext.Provider>
);

/** The attributes for a pop-up's content: spread them before the caller's own props. */
export const usePortalScope = () => React.useContext(PortalScopeContext);
